export default {
  'dots-vertical': 'mdi:dots-vertical',
  'information-outline': 'mdi:information-outline',
  plus: 'mdi:plus',
  minus: 'mdi:minus',
  exclamation: 'mdi:exclamation',
  'chevron-right': 'mdi:chevron-right',
  'chevron-left': 'mdi:chevron-left',
  'check-bold': 'mdi:check-bold',
  magnify: 'mdi:magnify',
  'menu-up': 'mdi:menu-up',
  'menu-down': 'mdi:menu-down',
  'content-copy': 'mdi:content-copy',
  'menu-right': 'mdi:menu-right',
  'chevron-down': 'mdi:chevron-down',
  'chevron-up': 'mdi:chevron-up',
  'alert-circle': 'mdi:alert-circle',
  'close-circle-outline': 'mdi:close-circle-outline',
  'arrow-right': 'mdi:arrow-right',
  close: 'mdi:close',
  rhombus: 'mdi:rhombus',
  'checkbox-marked-circle': 'mdi:checkbox-marked-circle',
  poll: 'mdi:poll',
  'circle-small': 'mdi:circle-small',
  'close-circle': 'mdi:close-circle',
  check: 'mdi:check',
  power: 'mdi:power',
  'pencil-outline': 'mdi:pencil-outline',
  'account-group': 'mdi:account-group',
  'bag-checked': 'mdi:bag-checked',
  'cog-outline': 'mdi:cog-outline',
  'open-in-new': 'mdi:open-in-new',
  'arrow-left': 'mdi:arrow-left',
  'flip-to-front': 'mdi:flip-to-front',
  'circle-outline': 'mdi:circle-outline',
  'check-circle': 'mdi:check-circle',
  'flag-variant': 'mdi:flag-variant',
  'eye-off-outline': 'mdi:eye-off-outline',
  sync: 'mdi:sync',
  'share-variant-outline': 'mdi:share-variant-outline',
  'file-open-outline': 'material-symbols-light:file-open-outline',
  'edit-outline': 'material-symbols-light:edit-outline',
  'delete-outline': 'material-symbols-light:delete-outline',
  'keep-outline': 'material-symbols-light:keep-outline',
  'content-copy-outline': 'material-symbols-light:content-copy-outline',
  'send-backward': 'mdi-light:arrange-send-backward',
  'file-document-outline': 'mdi:file-document-outline',
  'message-outline': 'mdi:message-outline',
  'tray-arrow-down': 'mdi:tray-arrow-down',
  menu: 'mdi-light:menu',
  'filter-list': 'material-symbols-light:filter-list',
  'power-light': 'material-symbols-light:power-settings-new',
  'refresh': 'material-symbols:refresh',
  'alert-circle-outline': 'mdi:alert-circle-outline',
  'megaphone': 'iconoir:megaphone',
  'tree-view': 'material-symbols-light:account-tree-outline-rounded',
  'tree-view-thick': 'material-symbols:account-tree-outline-rounded',
  'squares-four': 'ph:squares-four-light',
  'fact-check-line': 'si:fact-check-line',
  'leaderboard': 'iconoir:leaderboard',
  'sidebar': 'streamline-ultimate:sidebar-line-left',
  'arrow-up-right': 'bi:arrow-up-right',
  'clipboard-check-outline': 'mdi:clipboard-check-outline',
  'clock': 'mdi-light:clock',
  'people': 'radix-icons:people',
};
